;(function() {
  'use strict'

  controller.$inject = ["$scope", "facesService"];
  angular
    .module('app.messageClosedDialog')
    .controller('MessageClosedDialog', controller)

  /* @ngInject */
  function controller($scope, facesService) {
    $scope.moods = facesService.get()
    $scope.mood = _.find($scope.moods, { value: $scope.closeMood })

    $scope.getMoodStyle = getMoodStyle

    function getMoodStyle(mood) {
      if ($scope.mood.value === mood.value) {
        return {
          color: $scope.mood.color,
        }
      }
    }
  }
})()
